import { AttachFile } from '@mui/icons-material'
import { MenuItem } from '@mui/material'
import { useAttachFilesStore } from 'modules/orders/components/attachFiles/attachFilesStore'
import { ActionsItemProps } from './actions'

export const AttachFiles = ({ order, disabled }: ActionsItemProps) => {
  const setIsModalOpen = useAttachFilesStore.useSetModalOpen()
  const setOrderId = useAttachFilesStore.useSetOrderId()
  const setProposalId = useAttachFilesStore.useSetProposalId()

  const handleClick = () => {
    if (order.orderId) {
      setOrderId(order.orderId)
      setProposalId(null)
    } else if (order.proposalId) {
      setProposalId(order.proposalId)
      setOrderId(null)
    }
    setIsModalOpen(true)
  }

  return (
    <MenuItem onClick={handleClick} disabled={disabled}>
      <AttachFile />
      Anexar Arquivos
    </MenuItem>
  )
}
